import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import EmptyState from './empty_state';
import Header from './header';
import Row from './row';
import { columnConfig } from './config';

import './styles.scss';

export function ShadowsTable({ direction, shadows, sortBy, selectGlobalShadow }) {
  if (!shadows.length) {
    return <EmptyState/>;
  }

  const sortedShadows = useMemo(() => {
    if (sortBy) {
      return [...shadows].sort((s1, s2) => {
        const result = columnConfig[sortBy].getText(s1).localeCompare(columnConfig[sortBy].getText(s2));
        return direction === 'asc' ? result : result * -1;
      });
    } else {
      return shadows;
    }
  }, [direction, shadows, sortBy]);

  return (
    <table className="shadows-table">
      <Header />

      <tbody>
        {sortedShadows.map(shadow => (
          <Row 
            key={shadow.id} 
            selectGlobalShadow={selectGlobalShadow} 
            shadow={shadow} 
          />
        ))}
      </tbody>
    </table>
  );
}

ShadowsTable.propTypes = {
  direction: PropTypes.string,
  selectGlobalShadow: PropTypes.func,
  shadows: PropTypes.array.isRequired,
  sortBy: PropTypes.string,
};

const mapStateToProps = state => ({
  direction: state.shadowSort.direction,
  shadows: state.shadows.sorted,
  sortBy: state.shadowSort.sortBy,
});

export default connect(mapStateToProps)(ShadowsTable);
